import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import { Button, Col, Row } from 'antd';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

// -- Prop types
// ----------
export interface ISuperAdminCodebookListViewOwnProps {
}

type ISuperAdminCodebookListViewProps = ISuperAdminCodebookListViewOwnProps & IWithLocalizeOwnProps & WithRouterProps;

interface ISuperAdminCodebookListViewState {
}

export enum CodebookEnum {
  GRADE = 'grade',
  LOCATION = 'location',
  SKILL_LEVEL = 'skilllevel',
  ENROLLMENT_REQUIREMENT = 'enrollmentrequirement',
  EDUCATION_QUALIFICATION = 'educationqualification',
  EDUCATION_SECTOR = 'educationsector',
  EDUCATION_CATEGORY = 'educationcategory',
  USER_CATEGORY = 'usercategory',
}

// -- Component
// ----------

/** Display list of codebook edit pages
 * Codebooks are mapped from enum thus there are non-existing lower admin codebook
 */
class SuperAdminCodebookListView extends React.Component<ISuperAdminCodebookListViewProps, ISuperAdminCodebookListViewState> {
  state: ISuperAdminCodebookListViewState = {};

  render = () => {
    return (
      <React.Fragment>
        {Object.values(CodebookEnum).map((item) => {
          return (
            <Row justify="space-between" className="panel" key={item}>
              <Col>
                {this.props.translate(`CODEBOOK.TITLE_LABEL.${item}`)}
              </Col>
              <Col>
                <Button onClick={() => this.setPath(item)}> {this.props.translate('COMMON.ACTION_EDIT')} </Button>
              </Col>
            </Row>
          );
        })}
      </React.Fragment>
    );
  };

  setPath = (path: string) => {
    return this.props.router.push(`administration/codebooks/${path}`);
  };
}

// -- HOCs and exports
// ----------

export default withLocalize<ISuperAdminCodebookListViewOwnProps>(withRouter(SuperAdminCodebookListView as any));
